<template>
  <div>
    <scorebar-chart :chart-data="data" @Loaded="OnLoad"></scorebar-chart>
  </div>
</template>
<script>
  import Chart from '@/services/components/ScoreBarChart.vue';

  export default {
    data() {
      return {
        data: {},
        chart: undefined
      }
    },
    components: {
      "scorebar-chart": Chart
    },
    props: {
      chartData: { Object }
    },
    watch: {
      chartData: {
        handler(n, o) {
          this.data = n;
          this.Init();
          this.chart.renderChart(this.chart.chartData, this.chart.options);
        },
        deep: false
      }
    },
    methods: {
      OnLoad(chart) {
        this.chart = chart;
      },
      //Sort() {
      //  this.data.datasets.sort((a, b) => { return a.label > b.label ? 1 : -1 });
      //},
      Init() {
        //this.Sort();
      }
    },
    created() {
      this.data = this.chartData;
      this.Init();
    },
    mounted() {

    }
  }

</script>
